<template>
	<div class="footer">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					{{ translations.labels.footer }} <span><a href="mailto:support@e-screen.app">support@e-screen.app</a></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {

	color: lighten($color-text, 30%);
	font-size: 13px;
	margin-bottom: 30px;
	text-align: center;

	span {

		@include breakpoint(sm) {
			display: block;
		}

	}

}
</style>
